import {Botao, PaginaLogada} from "../../componentes";
import {Card} from "../../componentes/card/Card";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {exibirMensagemErro, exibirMensagemSucesso, HttpVerbo, xfetch} from "../../util";
import {BOTAO} from "../../config/constantes/constantes";

export default function AlterarNaturezaDespesa() {

  const navegacao = useNavigate()
  const params = useParams()

  const [natureza, setNatureza] = useState({})
  const [isCarregando, setIsCarregando] = useState(false)


  function consultaNatureza() {
    setIsCarregando(true)
    xfetch(`/naturezaDespesa/${params.id}`, {}, HttpVerbo.GET)
      .then( res => res.json())
      .then(dados => setNatureza(dados))
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    consultaNatureza()
  }, [])

  function alterar(e) {
    e.preventDefault()
    if (!natureza.nome) {
      exibirMensagemErro("Um nome para a natureza precisa ser informado")
      return
    }
    setIsCarregando(true)
    xfetch(`/naturezaDespesa/${natureza.id}/alterar`, natureza, HttpVerbo.POST)
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso("Natureza alterada com sucesso")
        navegacao('/novaNaturezaDespesa')
      })
      .finally(() => {
        setIsCarregando(false)
      })
  }

  return (
    <PaginaLogada titulo="Alterar Natureza" isCarregando={isCarregando}>
      <Card titulo="Alterar natureza">
        <div className="row">
          <div className="col-6">
            <input className="form-control"
               value={natureza.nome}
               onChange={(e) => setNatureza({...natureza, nome: e.target.value.toUpperCase()}) }/>
          </div>
          <div className="col-6">
            <Botao className={BOTAO.COR.SUCESSO} onClick={alterar}>Alterar</Botao>
          </div>
        </div>
      </Card>
    </PaginaLogada>
  );
}